import {
    defineStore,
} from 'pinia';
import {
    reactive, toRefs,
} from 'vue';

export const useOriginStore = defineStore('profile-origin', () => {
    const state = reactive({
        origin: 'ONE_PAGER_WORK_MANUAL',
    });

    function setOrigin(newOrigin) {
        state.origin = newOrigin;
    }

    return {
        ...toRefs(state),
        setOrigin,
    };
});
